import state from './promoListState'
import getters from './promoListGetters'
import actions from './promoListActions'
import mutations from './promoListMutations'

export default {
  namespaced : true,
  state : state,
  getters : getters,
  actions : actions,
  mutations : mutations
}
